module.exports = new __parcel__URL__("mRESVIA_product.50afa9e6.jpg").toString();